export default "__VITE_ASSET__Chw7GUh3__"